export var concat = function (array, target) {
    var arr = [];
    for (var i = 0; i < array.length; i++) {
        arr.push(array[i]);
    }
    arr.push(target);
    return arr;
};
